<template>
    <div class="text-white" id="footer">
        <div class="container">
            <div class="row p-lg-6 py-6">
                <div class="col-12 col-lg-6 col-md-6 mb-lg-0 mb-5">
                    <router-link class="nav-link text-uppercase" :to="{ name: 'home' }">
                        <img id="logo" src="@/assets/images/footer-logo.png" alt="hsol" width="316" class="d-inline-block align-top logo" /></router-link>
                </div>
                <div class="col-12 col-sm-4 col-lg-2 col-md-2 mb-lg-0 mb-5">
                    <h4 class="text-muted">Company</h4>
                    <nav class="nav flex-column">
                        <router-link class="nav-link text-muted" :to="{ name: 'about' }">About Us</router-link>
                        <!-- <router-link class="nav-link text-muted" :to="{ name: 'terms' }">Terms</router-link> -->
                        <!-- <router-link class="nav-link text-muted" :to="{ name: 'privacy' }">Privacy</router-link> -->
                    </nav>
                </div>

                <div class="col-12 col-sm-4 col-lg-2 col-md-2 mb-lg-0 mb-5">
                    <h4 class="text-muted">Services</h4>
                    <nav class="nav flex-column">
                        <router-link class="nav-link text-muted" :to="{ name: 'gallery' }">Project Gallery</router-link>
                        <a class="nav-link text-muted" href="/#residential">Residential</a>
                        <a class="nav-link text-muted" href="/#multiresidential">Muilti-Residential</a>
                        <a class="nav-link text-muted" href="/#renovations">Renovations</a>
                        <a class="nav-link text-muted" href="/#rendering">3D Design Rendering</a>
                    </nav>
                </div>

                <div class="col-12 col-sm-4 col-lg-2 col-md-2 mb-lg-0 mb-5">
                    <h4 class="aligncenter text-muted">Links</h4>
                    <nav class="nav flex-column">
                        <router-link class="nav-link text-muted" :to="{ name: 'contact' }">Contact Us</router-link>
                        <a class="nav-link text-muted" href="tel:0262601042">(02) 6260 1042</a>
                        <!-- <a class="nav-link text-muted" href="https://www.facebook.com/Home-Solutions-118413178233036/" target="_blank">Facebook</a> -->
                    </nav>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			//
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/navigation/Footer.vue